/**
 * Store Types TVA
 *
 */
export default {
    getters: {
        /**
         * Permet de retourner si le type de TVA est par annuel, trimestriel, ou mensuel
         */
        typesTVA : state => regime_tva => {
            switch (regime_tva) {
                case 'N/C': return ['annee']
                case 'RS': return ['annee', 'semestre']
                case 'MRT': return ['trimestre']
                case 'MRM': return ['mois']
                default: return []
            }
        }
    }
}
